import { render, staticRenderFns } from "./tablePlan.vue?vue&type=template&id=e028d4e8&scoped=true"
import script from "./tablePlan.vue?vue&type=script&lang=js"
export * from "./tablePlan.vue?vue&type=script&lang=js"
import style0 from "./tablePlan.vue?vue&type=style&index=0&id=e028d4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e028d4e8",
  null
  
)

export default component.exports